import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { faqs } from '../data';

const FAQ_IMAGE = 'https://cloud.sharemyimage.com/2026/09/12/FAQ.png';

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section className="faq-section" id="faqs">
      <div className="container faq-layout">
        <div className="faq-main">
          <span className="eyebrow">Helpful answers</span>
          <h2>Frequently Asked Questions</h2>
          <div className="faq-grid">
            {faqs.map(([question, answer], index) => (
              <article className={`faq-item ${open === index ? 'open' : ''}`} key={question}>
                <button onClick={() => setOpen(open === index ? -1 : index)}>
                  <span>{question}</span>
                  <SafeIcon icon={open === index ? FiIcons.FiMinus : FiIcons.FiPlus} />
                </button>
                <div className="faq-answer"><p>{answer}</p></div>
              </article>
            ))}
          </div>
        </div>
        <div className="faq-image-wrap">
          <img src={FAQ_IMAGE} alt="OtterWorks team ready to answer your questions" />
        </div>
      </div>
    </section>
  );
}